import {Row, Col} from 'react-bootstrap'
import PricingPlan3 from '../../mycomp/ExtraPages/PricingPlan/PricingPlanStyle3';


const BillingPlan = () =>{
    return(

        <>
            <Row>
                <Col sm={12} lg={12}>
                    <PricingPlan3 />
                </Col>
            </Row>
        </>

    );
};

export default BillingPlan;